import { ChangeDetectorRef, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { SubscriptionManager } from '@core/shared/utils';
import { UiTooltipContentComponent } from './tooltip-content.component';
import * as i0 from "@angular/core";
export var TooltipTrigger = /*#__PURE__*/function (TooltipTrigger) {
  TooltipTrigger["click"] = "click";
  TooltipTrigger["hover"] = "hover";
  TooltipTrigger["none"] = "none";
  return TooltipTrigger;
}(TooltipTrigger || {});
export let UiTooltipTriggerDirective = /*#__PURE__*/(() => {
  class UiTooltipTriggerDirective {
    set _content(newValue) {
      if (newValue === this._content) return;
      this.content = newValue;
    }
    set _options(newValue) {
      this.options = newValue;
    }
    constructor(vcr, cd, elRef, renderer) {
      this.vcr = vcr;
      this.cd = cd;
      this.elRef = elRef;
      this.renderer = renderer;
      this.options = {
        trigger: TooltipTrigger.click
      };
      this.permanentListeners = new SubscriptionManager();
      this.temporaryListeners = new SubscriptionManager();
    }
    ngOnInit() {
      if (!this.content) throw new Error('no tooltip-content has been assigned to the tooltipTrigger directive!');
      this.bindPermanentListeners();
      if (!this.content.referenceObject) {
        this.content.referenceObject = this.elRef.nativeElement;
      }
    }
    toggle(trigger = 'external') {
      const isVisible = this.content.status.visible;
      isVisible ? this.hide(trigger) : this.show(trigger);
    }
    hide(trigger = 'external') {
      this.temporaryListeners.clear();
      this.content.hide({
        trigger
      });
    }
    show(trigger = 'external') {
      this.content.show({
        trigger
      });
      this.bindTemporaryListeners();
    }
    // ========== DOM LISTENERS SETUP ==============================================================
    bindPermanentListeners() {
      switch (this.options.trigger) {
        case TooltipTrigger.click:
          this.createHostElementListener("click", () => this.toggle('click'));
          break;
        case TooltipTrigger.hover:
          this.createHostElementListener("mouseenter", () => this.show('mouse-enter'));
          this.createHostElementListener("mouseleave", () => this.hide('mouse-leave'));
          break;
      }
    }
    bindTemporaryListeners() {
      ["touchend", "touchcancel", "mouseleave"].forEach(eventName => {
        this.createHostElementListener(eventName, () => this.hide);
      });
    }
    createHostElementListener(name, handler, permanentSubscription = true) {
      const subscr = this.renderer.listen(this.elRef.nativeElement, name, event => {
        event.stopPropagation();
        handler();
      });
      this[permanentSubscription ? 'permanentListeners' : 'temporaryListeners'].add(subscr);
    }
    ngOnDestroy() {
      this.permanentListeners.clear();
    }
    static {
      this.ɵfac = function UiTooltipTriggerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTooltipTriggerDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: UiTooltipTriggerDirective,
        selectors: [["", "uiTooltipTrigger", ""]],
        inputs: {
          _content: [0, "uiTooltipTrigger", "_content"],
          _options: [0, "uiTooltipTriggerOptions", "_options"]
        }
      });
    }
  }
  return UiTooltipTriggerDirective;
})();